import React from 'react';
import { Link } from 'react-router-dom';

const Sartlar: React.FC = () => {
  return (
    <div className="page-content">
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>
            Kurye Şartları
          </h1>
          <p style={{ fontSize: '1.125rem', opacity: 0.9, lineHeight: 1.6 }}>
            Motopack ailesine katılmak için gereken şartları inceleyin.
          </p>
        </div>
      </section>

      <section className="about-content" style={{ background: 'var(--bg-primary)', paddingTop: '2.5rem', paddingBottom: '2.5rem' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '2.2rem' }}>
            <h2 style={{ fontWeight: 800, fontSize: '2rem', color: 'var(--primary-color)', marginBottom: '0.7rem' }}>Kurye Türlerine Göre Şartlar</h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem' }}>Hangi kurye türüne başvurmak istediğinize göre gereken şartları kontrol edin.</p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
            gap: '2.5rem',
            alignItems: 'stretch',
            justifyItems: 'center',
          }}>

            {/* Motorlu Kurye Şartları */}
            <div style={{
              background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
              borderRadius: '24px',
              boxShadow: '0 4px 20px 0 rgba(0,0,0,0.08), 0 2px 8px 0 rgba(0,0,0,0.04)',
              padding: '2.5rem',
              display: 'flex',
              flexDirection: 'column',
              gap: '1.5rem',
              minHeight: '500px',
              width: '100%',
              maxWidth: 550,
              position: 'relative',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'pointer',
              border: '1px solid rgba(0,0,0,0.05)',
            }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 12px 40px 0 rgba(0,102,204,0.15), 0 4px 12px 0 rgba(0,102,204,0.08)';
                (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-4px) scale(1.02)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 20px 0 rgba(0,0,0,0.08), 0 2px 8px 0 rgba(0,0,0,0.04)';
                (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0) scale(1)';
              }}
            >
              {/* Dekoratif Arka Plan */}
              <div style={{
                position: 'absolute',
                top: '-20px',
                right: '-20px',
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                borderRadius: '50%',
                opacity: 0.1,
                zIndex: 0,
              }}></div>

              <div style={{
                background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                color: 'white',
                padding: '2rem',
                borderRadius: '20px',
                marginBottom: '1.5rem',
                textAlign: 'center',
                position: 'relative',
                zIndex: 1,
                boxShadow: '0 4px 16px 0 rgba(0,102,204,0.2)',
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{ marginRight: '0.5rem' }}>
                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <h3 style={{ fontWeight: 800, fontSize: '1.6rem', margin: 0, color: 'white' }}>Motorlu Kurye İçin Şartlar</h3>
                </div>
                <p style={{ margin: 0, opacity: 0.9, fontSize: '0.95rem' }}>Motosiklet ile teslimat yapmak için gereken koşullar</p>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', position: 'relative', zIndex: 1 }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>1</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>18 yaşını doldurmuş olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>2</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>T.C. vatandaşı olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>3</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>P1 (Yetki) belgesine sahip olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>4</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>MYK (Kurye Seviye 3) belgesi olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>5</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>En az 1 yıl kurye deneyimi</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>6</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Vergi levhasına sahip olmak (esnaf kurye)</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>7</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>En az 100 cc motosiklete sahip olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>8</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Motosiklet ruhsatı başvuru sahibine ait ya da noter izinli</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>9</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Geçerli A, A1 veya A2 ehliyeti olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>10</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Trafik sigortası ve araç muayenesi güncel olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>11</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Akıllı telefon kullanabiliyor olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>12</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Harita ve navigasyon uygulamalarına hâkim olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>13</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Trafik kurallarına ve güvenli sürüşe uygunluk</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>14</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Esnek çalışma saatlerine uyumlu olmak</p>
                </div>
              </div>
            </div>

            {/* Araçlı Kurye Şartları */}
            <div style={{
              background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
              borderRadius: '24px',
              boxShadow: '0 4px 20px 0 rgba(0,0,0,0.08), 0 2px 8px 0 rgba(0,0,0,0.04)',
              padding: '2.5rem',
              display: 'flex',
              flexDirection: 'column',
              gap: '1.5rem',
              minHeight: '500px',
              width: '100%',
              maxWidth: 550,
              position: 'relative',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'pointer',
              border: '1px solid rgba(0,0,0,0.05)',
            }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 12px 40px 0 rgba(0,102,204,0.15), 0 4px 12px 0 rgba(0,102,204,0.08)';
                (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-4px) scale(1.02)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 20px 0 rgba(0,0,0,0.08), 0 2px 8px 0 rgba(0,0,0,0.04)';
                (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0) scale(1)';
              }}
            >
              {/* Dekoratif Arka Plan */}
              <div style={{
                position: 'absolute',
                top: '-20px',
                right: '-20px',
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                borderRadius: '50%',
                opacity: 0.1,
                zIndex: 0,
              }}></div>

              <div style={{
                background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                color: 'white',
                padding: '2rem',
                borderRadius: '20px',
                marginBottom: '1.5rem',
                textAlign: 'center',
                position: 'relative',
                zIndex: 1,
                boxShadow: '0 4px 16px 0 rgba(0,102,204,0.2)',
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{ marginRight: '0.5rem' }}>
                    <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M5 17h-2v-6l2-5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <h3 style={{ fontWeight: 800, fontSize: '1.6rem', margin: 0, color: 'white' }}>Araçlı Kurye İçin Şartlar</h3>
                </div>
                <p style={{ margin: 0, opacity: 0.9, fontSize: '0.95rem' }}>Araç ile teslimat yapmak için gereken koşullar</p>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', position: 'relative', zIndex: 1 }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>1</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>18 yaşını doldurmuş olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>2</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>T.C. vatandaşı olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>3</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>P1 Yetki Belgesine sahip olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>4</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>En az 1 yıl aktif araçlı kurye deneyimi</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>5</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>SRC belgesine sahip olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>6</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Psikoteknik değerlendirme raporuna sahip olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>7</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Panelvan veya minivan araca sahip olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>8</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Araç ruhsatı başvuru sahibine ait olmalı veya noter kullanım izni olmalı</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>9</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Geçerli B sınıfı ehliyete sahip olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>10</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Trafik sigortası ve araç muayenesi güncel olmalı</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>11</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Vergi levhasına sahip olmak (esnaf kurye)</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>12</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Akıllı telefon kullanabiliyor olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>13</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Navigasyon ve harita uygulamalarına hâkim olmak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>14</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Trafik kurallarına ve güvenli sürüş kurallarına uymak</p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,102,204,0.1)',
                  transition: 'all 0.2s ease',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,1)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.8)';
                    e.currentTarget.style.borderColor = 'rgba(0,102,204,0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div style={{
                    background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--primary-color) 100%)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px 0 rgba(0,102,204,0.3)',
                  }}>15</div>
                  <p style={{ margin: 0, color: 'var(--text-primary)', lineHeight: 1.6, fontWeight: 500 }}>Yoğun çalışma temposuna ve esnek saatlere uyum sağlamak</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Bölümü */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h2 style={{
            fontSize: '1.75rem',
            fontWeight: 700,
            color: '#fff',
            marginBottom: '0.75rem',
          }}>
            Şartları Karşılıyor musunuz?
          </h2>
          <p style={{
            fontSize: '1rem',
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '1.5rem',
          }}>
            Motopack ailesine katılmak için hemen başvurunuzu yapın.
          </p>
          <div style={{
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <Link
              to="/kuryeol"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: '#fff',
                color: '#0066CC',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                textDecoration: 'none',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              Hemen Başvur
            </Link>
            <Link
              to="/iletisim"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: 'transparent',
                color: '#fff',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                border: '1.5px solid rgba(255,255,255,0.5)',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                e.currentTarget.style.borderColor = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
              }}
            >
              Sorularınız İçin
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sartlar; 